import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import consola from 'consola';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';
import TcVars from '~/components/functional/TcVars/EditorialTcVars.vue';
import { PRISMIC_URL } from '~/const/3rd';
import { formatPrismicImage } from '~/helpers/image-helper';
import { componentList, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
var components = {};
componentList().forEach(function (e) {
  components[e.type || e.name] = function (slug) {
    return {
      component: import("~/components/organisms/Editorial/".concat(slug))
    };
  };
});
export default {
  validate: function validate(_ref) {
    var _ref$params = _ref.params,
        alias = _ref$params.alias,
        slug = _ref$params.slug;
    return alias && (slug || 'landing');
  },
  name: 'Article',
  components: {
    Seo: Seo,
    OpenGraph: OpenGraph,
    TcVars: TcVars,
    RatingJsonLd: RatingJsonLd
  },
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=3600, public'
    };
  },
  asyncData: function () {
    var _asyncData = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref2) {
      var error, _ref2$params, alias, _ref2$params$slug, slug, apolloProvider, store, definition, content, _content$results, _content$results$, id, data, tags, slices, eventCategory, eventAction, eventLabel, tracking;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              error = _ref2.error, _ref2$params = _ref2.params, alias = _ref2$params.alias, _ref2$params$slug = _ref2$params.slug, slug = _ref2$params$slug === void 0 ? 'landing' : _ref2$params$slug, apolloProvider = _ref2.app.apolloProvider, store = _ref2.store;
              _context.prev = 1;
              definition = typeDefinition(alias);
              _context.next = 5;
              return fetchContent(store, {
                type: definition.type,
                slug: slug,
                alias: alias
              });

            case 5:
              content = _context.sent;

              if (content.results.length) {
                _context.next = 9;
                break;
              }

              error({
                statusCode: 404,
                message: 'Not Found'
              });
              return _context.abrupt("return", false);

            case 9:
              _content$results = _slicedToArray(content.results, 1), _content$results$ = _content$results[0], id = _content$results$.id, data = _content$results$.data, tags = _content$results$.tags;

              if (!(data.alias && data.alias !== alias)) {
                _context.next = 13;
                break;
              }

              error({
                statusCode: 404,
                message: 'Not Found'
              });
              return _context.abrupt("return", false);

            case 13:
              _context.next = 15;
              return buildSlices(definition, data, apolloProvider.defaultClient, store);

            case 15:
              slices = _context.sent;
              eventCategory = data.event_category, eventAction = data.event_action, eventLabel = data.event_label;
              tracking = {
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: eventLabel
              };
              return _context.abrupt("return", {
                type: definition.type,
                template: {
                  path: definition.path,
                  data: data,
                  tracking: tracking
                },
                id: id,
                tags: tags,
                slices: slices
              });

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](1);
              error({
                statusCode: 404,
                message: 'Not Found'
              });

            case 24:
              return _context.abrupt("return", false);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 21]]);
    }));

    function asyncData(_x) {
      return _asyncData.apply(this, arguments);
    }

    return asyncData;
  }(),
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    tcVars: function tcVars() {
      return this.template ? _objectSpread({}, this.template.data, {
        env_template: this.template.data.env_template || 'Landing Page'
      }) : {};
    }
  }),
  created: function created() {
    var _this = this;

    if (this.template.path) {
      this[this.type] = function () {
        return components[_this.type](_this.template.path);
      };
    }

    this.slices.forEach(function (_ref3) {
      var type = _ref3.type,
          path = _ref3.path;

      _this[type] = function () {
        return components[type](path);
      };
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    var prismicEdit = this.$cookies.get('editor');

    if (prismicEdit) {
      window.prismic = {
        endpoint: this.$store.state.sharedEnv.payload.prismic
      };
      this.asyncScript(PRISMIC_URL).then(function () {}).catch(function (err) {
        consola.error('PRISMIC FAILED', err);

        _this2.$logger.error("PRISMIC FAILED ".concat(err));
      });
    }
  },
  methods: {
    currentComponent: function currentComponent(arg) {
      return this[arg];
    },
    options: function options(_ref4) {
      var backgroundColor = _ref4.global_background_color,
          image = _ref4.global_background_image;
      return process.browser ? _objectSpread({}, backgroundColor && {
        style: {
          backgroundColor: backgroundColor
        }
      }, image && image.url && {
        'data-bgset': formatPrismicImage(image.url),
        class: 'lazyload bg-center'
      }) : null;
    }
  }
};